import purchaseOrder from './purchase-order'
import supplier from './supplier'

export default {
  namespaced: true,
  modules: { purchaseOrder, supplier }
}
